"use strict";

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const PurchaseTracking = require('../../../global/mixins/purchaseTracking.es');
const get = require('lodash.get');
const netPriceLauncher = require('../../../contact/netPrice/helpers/netPriceLauncher');
const Tour = require('../../Tour/Tour');
const copy = require('../../../../../json/copy/itemActionButtons.json');

class RequestNetPriceButton extends ContextComponent {
    constructor(props) {
        super(props);
        this.onNetPriceClick = this.onNetPriceClick.bind(this);
        if (props.tracking) {
            this.purchaseTracking = new PurchaseTracking({ item: props.item, pageContext: this.props.tracking.pageContext });
        }
    }

    _trackNetPriceClick() {
        if (this.purchaseTracking) {
            this.purchaseTracking.trackNetPriceEvent({
                actionSuffix: 'clicked'
            });
        }
    }

    onNetPriceClick(e) {
        e.preventDefault();
        this._trackNetPriceClick();
        netPriceLauncher(Object.assign({
            itemPk: this.props.item.get('id'),
            purchaseTracking: this.purchaseTracking,
            linkLocation: get(this.props.tracking, 'pageContext'),
            context: this.context
        }, this.props));
    }

    render() {
        const { tradeTour = {}} = this.props;
        const cls = `button button-secondary ${this.props.buttonClass}`;
        const requestCta = (
            <a className={cls} href="#request-net-price" data-tn="item-actions-request-net-price" onClick={e => this.onNetPriceClick(e)}>
                {copy.requestNetPrice}
            </a>
        );

        if (tradeTour && tradeTour.type) {
            return (
                <Tour className="button-wrapper" dataTn="request-net-price" step={1} {...tradeTour}>
                    {requestCta}
                </Tour>
            );
        }

        return requestCta;
    }
}

RequestNetPriceButton.propTypes = {
    item: PropTypes.object.isRequired,
    buttonClass: PropTypes.string,
    tracking: PropTypes.object,
    tradeTour: PropTypes.object
};

RequestNetPriceButton.defaultProps = {
    buttonClass: 'button-large'
};

module.exports = RequestNetPriceButton;



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/RequestNetPriceButton/RequestNetPriceButton.jsx